import { Box } from '@material-ui/core';
import useFormatNumber from '../hooks/useFormatNumber';
import { withStyles } from '@material-ui/core/styles';

const PositiveNumber = withStyles((theme) => ({
  root: {
    color: theme.palette.success.dark,
  },
}))(Box);

const NegativeNumber = withStyles((theme) => ({
  root: {
    color: theme.palette.warning.dark,
  },
}))(Box);

export default function NumberFormat({
  value: rawValue,
  minimumFractionDigits = 0,
  style = 'currency',
  frequency,
  withColor,
  debitColor,
  creditColor,
  abs = false,
  showZero = true,
  ...props
}) {
  const formatNumber = useFormatNumber();
  const value = abs ? Math.abs(rawValue) : rawValue;

  // Determine the value to display
  const isZeroOrEmpty = value === undefined || value === null || rawValue === 0;
  const shouldShowZero = showZero || !isZeroOrEmpty;
  
  // Format the value to display
  const formattedValue = shouldShowZero 
    ? formatNumber(value, style, minimumFractionDigits)
    : '--';
  
  // Add frequency if provided
  const displayText = frequency 
    ? `${formattedValue} / ${frequency}` 
    : formattedValue;

  // Determine which component to use
  const shouldUseNegative = (withColor && rawValue < 0) || debitColor;
  const shouldUsePositive = (withColor && rawValue >= 0) || creditColor;

  // Determine wrapper component
  let WrapperComponent = Box;
  if (shouldUseNegative) {
    WrapperComponent = NegativeNumber;
  } else if (shouldUsePositive) {
    WrapperComponent = PositiveNumber;
  }

  return (
    <WrapperComponent whiteSpace="nowrap" {...props}>
      {displayText}
    </WrapperComponent>
  );
}
